/**
 * Adapted from product_full_shades_v2
 */

var prodcat = prodcat || {};
var site = site || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product-full', function (e, skuBaseId, hasDramming) {
    var $product = $(this);
    var $shadesGrid = $product.find('.js-product-vto-shades-grid');
    var $shadeArrayItem = $('.js-product-vto-shades-array-item', $product);
    var $selectedShade;

    // Don't execute only on init for dramming product
    if (hasDramming === 'noshade') {
      return;
    }

    if (typeof skuBaseId === 'undefined') {
      skuBaseId = prodcat.ui.getSkuIdByProduct($(this));
    }
    $selectedShade = $shadesGrid.find(
      '.js-product-vto-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]'
    );

    if ($shadesGrid.length < 1) {
      return;
    }
    $product.attr('data-sku-base-id', skuBaseId);

    if (hasDramming) {
      $('.js-product-vto-shades-grid-item.secondactive', $product)
        .removeClass('active secondactive')
        .attr('aria-selected', false);
      $selectedShade.addClass('active secondactive').attr('aria-selected', true);
    } else {
      $shadeArrayItem.not('.secondactive').removeClass('active').attr('aria-selected', false);
      $selectedShade.addClass('active').attr('aria-selected', true);
    }
  });

  $(document).on('inv_status_display:updated', '.js-product-full', function () {
    var $product = $(this);
    var $shadeGrid = $product.find('.js-product-vto-shades-grid');
    var $items = $shadeGrid.find('.js-product-vto-shades-grid-item');

    $items.each(function () {
      var $this = $(this);
      var enableReorder = $this.closest($shadeGrid).find($items).length > 1;
      var skuBaseId = $this.data('sku-base-id');
      var currentInvStatus = $this.data('inventoryStatus');
      var skuDataL2 = prodcat.data.getSku(skuBaseId);
      var invStatus;

      if (!skuDataL2) {
        if (currentInvStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }
        return;
      }

      invStatus = skuDataL2.INVENTORY_STATUS;
      if (currentInvStatus === invStatus && invStatus !== 1 && enableReorder) {
        $this.closest($shadeGrid).append($this);
      }

      // Update Shade Inventory Status
      if (parseInt(currentInvStatus, 10) !== parseInt(invStatus, 10)) {
        $this.removeClass('shade-inv-status--' + currentInvStatus);
        $this.addClass('shade-inv-status--' + invStatus);
        $this.attr('data-inventory-status', invStatus).data('inventoryStatus', invStatus);
        if (invStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }
      }
    });
  });

  Drupal.behaviors.productVtoShadesV1 = {
    toggleShade: false,
    drammingPage: false,
    attached: false,
    attach: function (context) {
      var self = this;
      var $templates = $('.js-product-vto-shades-v1', context);

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.$addBtn = $('.js-add-to-cart', '.js-product-dramming');

      $templates.each(function () {
        var $template = $(this);

        self.initShadesCarousel($template);
        $(window).on(
          'resize',
          _.debounce(function () {
            self.initShadesCarousel($template);
            self.showPerfectMatchTabSelected(context);
          }, 100)
        );
        self.setEvents($template);
      });

      /**
       * When VTO is loaded, select the currently active filter if there is one,
       * otherwise select a default filter, but only if this sku has a filter set.
       */
      var $vtoShadesFilterSet = $('.js-product-vto-shades-filter-set', context);
      if ($vtoShadesFilterSet.length > 0) {
        var $productVTO = $('.js-product-vto-v1, .js-product-vto-v2', context);
        $productVTO.on('productVTO:loaded', function () {
          var $productFull = $vtoShadesFilterSet.closest('.js-product-full');
          var $activeFilter = $productFull.find('.js-product-full-shade--filter.active').first();

          var activeFilterValue = $activeFilter.data('filter');
          var $targetFilter;

          if (activeFilterValue) {
            $targetFilter = $vtoShadesFilterSet.find(
              '.js-product-full-shade--filter[data-filter="' + activeFilterValue + '"]'
            );
          }

          if (!$targetFilter || $targetFilter.length === 0) {
            $targetFilter = $vtoShadesFilterSet.find('.js-product-full-shade--filter').first();
          }

          $targetFilter.trigger('click');
        });
      }

      self.showPerfectMatchTabSelected(context);
    },

    setEvents: function ($template) {
      var self = this;
      var $product = $template.closest('.js-product-full');
      var $shadesWrapper = $('.js-product-full-overlay-shades', $product);
      var $shadesGrid = $('.js-product-vto-shades-grid', $product);
      var $shadesArray = $('.js-product-vto-shades-array', $product);
      var $shadesGridItem = $('.js-product-vto-shades-grid-item', $shadesGrid);
      var $shadesArrayItem = $('.js-product-vto-shades-array-item', $shadesArray);
      var $shadesFilterItem = $('.js-product-full-shade--filter', $product);
      var $shadeHeader = $('.js-shades-header-title', $product);
      var $shadesTitle = $('.js-shades-title', $product);
      var $selectTitle = $('.js-select-title', $product);
      var $filterContainer = $('.js-shades-filter', $product);
      var $filterSet = $('.js-filter-set', $product);
      var $filterInfo = $('.js-filter-info', $product);
      var $filterwrapper = $('.js-filter-info-wrapper', $product);
      var $filterArrow = $('.js-filter-arrow', $product);
      var $shadesFlyout = $('.js-product-vto-shades-flyout-v2', $product);
      var $ffCopy = $('.js-ff-personalization', $product);
      var $shadeName = $('.js-sku-shade-name', $product);
      var $shadeDot = $('.js-product-vto-shades-overlay__selected-shade .js-shade-dot', $product);
      var $shadeDesc = $('.js-sku-shade-description', $product);
      var $shadeList = $('.js-product-vto-shades-grid-view', $product);
      var $shadeGridPerfectMatch = $('.js-product-full-overlay-perfectmatch', $product);
      var $shadeTabPerfectMatch = $('.js-product-full-shade--perfect-match', $product);
      var $activeGridItems;
      var skuCount;

      // Select first shade if default sku isn't in stock
      $(function () {
        var $fullShades = $('.js-product-vto-shades-v1', $product);
        var $items = $shadesGrid.find('.js-product-vto-shades-grid-item');

        $shadesGrid = $('.js-product-vto-shades-grid-content', $fullShades);
        $items.each(function () {
          var $this = $(this);
          var skuBaseId = $this.data('sku-base-id');
          var skuData = prodcat.data.getSku(skuBaseId);
          var invStatus = skuData.INVENTORY_STATUS;
          var isOrderable = skuData.isOrderable;
          var defaultStatus = skuData.DEFAULT_SKU;

          if (invStatus !== 1 && isOrderable === 0) {
            if ($this.hasClass('active') || defaultStatus === 1) {
              skuBaseId = $shadesGrid.find($shadesGridItem).first().data('sku-base-id');
              $product.trigger('product.skuSelect', skuBaseId).once();
            }
          }
        });
      });

      $(document).on('productShade:toggleShadeTabs', function (e, perfectMatchTab) {
        if (perfectMatchTab === 'perfect_match') {
          $shadeGridPerfectMatch.show();
          $shadesWrapper.hide();
          $shadesFlyout.addClass('perfect-match-active');
        } else {
          $shadeGridPerfectMatch.hide();
          $shadesWrapper.show();
          $shadesFlyout.removeClass('perfect-match-active');
        }
      });

      site.restrict_navigation($filterSet);
      $filterwrapper.add($shadesGridItem).on('keydown', function (e) {
        if (e.key === 'Enter') {
          $(this).trigger('click');
        }
      });

      $filterwrapper.once().on('click', function () {
        $selectTitle.add($shadesTitle).toggleClass('hidden');
        $shadeHeader.toggleClass('expanded');
        $filterSet.add($filterInfo).toggleClass('hidden');
        $filterArrow.toggleClass('rotated');
      });

      $shadesArrayItem.once().on('click', function (event) {
        event.preventDefault();
        var $this = $(this);
        var skuBaseId = $this.data('sku-base-id');

        // Restrict the second click on the same shade
        if ($this.hasClass('active')) {
          return;
        }
        $product.trigger('product.skuSelect', [skuBaseId, self.toggleShade]);
        self.loadSelectedShade(skuBaseId, null, $product, $shadesFilterItem);
        $shadesArrayItem.attr('aria-selected', false);
        $this.attr('aria-selected', true);
        $ffCopy.removeClass('hidden');

        if (self.drammingPage) {
          self.toggleShade = !self.toggleShade;
        }
      });

      $shadesArrayItem.on('mouseover', function () {
        var $this = $(this);
        var skuBaseId = $this.data('sku-base-id');
        var skuData = prodcat.data.getSku(skuBaseId);

        // Restrict the second click on the same shade
        if ($this.hasClass('hovered')) {
          return;
        }
        $shadesArrayItem.removeClass('hovered');
        $this.addClass('hovered');
        $ffCopy.addClass('hidden');
        $shadeName.text(skuData['SHADENAME']);
        $shadeDesc.text(skuData['SHADE_DESCRIPTION']);
        $shadeDot.css({ backgroundColor: skuData['HEX_VALUE_STRING'] });

        if (self.drammingPage) {
          self.toggleShade = !self.toggleShade;
        }
      });

      $shadesArrayItem.on('mouseleave', function () {
        $shadesArrayItem.removeClass('hovered');
        $ffCopy.removeClass('hidden');
      });

      $shadeTabPerfectMatch.once().on('click tab', function () {
        var $perfectMatchTab = $(this);
        var $parentPerfectMatchTab = $perfectMatchTab.closest('.js-product-vto-shades-flyout-v2');
        var $productFullPerfectMatch = $parentPerfectMatchTab.find(
          '.js-product-full-perfect-match'
        );
        var skuBaseId = $productFullPerfectMatch.attr('data-sku-base-id');

        $product.trigger('product.skuSelect', skuBaseId);
        $perfectMatchTab.trigger('productShade:choosePerfectMatch');
      });

      $shadeTabPerfectMatch.on('productShade:choosePerfectMatch', function () {
        var $shadesTabsFlyout = $('.js-product-full-shade--filter', $shadesFlyout);

        $shadesTabsFlyout.removeClass('active');
        $(document).trigger('productShade:toggleShadeTabs', ['perfect_match']);
        $(this).addClass('active');
      });

      $shadesFilterItem.on('keydown', function (e) {
        if (e.key === 'Enter') {
          $(this).trigger('click');
        }
      });

      $shadesFilterItem.once().on('click', function (e) {
        var $tab = $(this);
        var colorFamily = $tab.data('filter');
        var selectedFilter = $tab.contents().not($tab.children()).text();

        e.preventDefault();

        $shadeList.removeClass('expanded');
        $('.js-product-full-shade--perfect-match').removeClass('active');
        $(document).trigger('productShade:toggleShadeTabs');
        $product.trigger('product.showColorFamily', [colorFamily]);
        $filterSet.add($selectTitle).addClass('hidden');
        $shadeHeader.removeClass('expanded');
        $shadesTitle.add($filterInfo).removeClass('hidden');
        $('.js-filter-selected', $filterInfo).text(selectedFilter);
        $filterArrow.removeClass('rotated');
        $shadesFilterItem.attr('aria-selected', false);
        $tab.attr('aria-selected', true);
      });

      $(document).on('product.showColorFamily', '.js-product', function (e, colorFamily) {
        var defaultFamily = 'all';
        var selectedColorFamily;
        var $selectedShade = $shadesGrid.find('.js-product-vto-shades-grid-item.active').first();
        var skuBaseId = $selectedShade.data('sku-base-id');
        var $overlayListItem = $('.js-product-vto-shades-overlay-list-item', $shadesFlyout);
        $shadesFilterItem.removeClass('active');
        $shadesFilterItem.each(function () {
          selectedColorFamily = $(this).data('filter');
          if (
            typeof selectedColorFamily !== typeof undefined &&
            selectedColorFamily === colorFamily
          ) {
            $(this).addClass('active');
          }
        });
        $shadesGridItem.removeClass('hidden');

        if (colorFamily !== defaultFamily) {
          $shadesGridItem.each(function () {
            var $shade = $(this);
            var shadeFamily = $shade.data('shade-family');

            if (shadeFamily) {
              shadeFamily = shadeFamily.replace(/\s+/g, '').toLowerCase().split(',');
              if (shadeFamily.indexOf(colorFamily.toLowerCase()) === -1) {
                $shade.addClass('hidden');
              }
            }
          });
        }
        if ($('body').hasClass('overlay-shades-active')) {
          $activeGridItems = $shadesFlyout.find($shadesGridItem);

          // Mobile Overlay Filter shows active shade
          if ($activeGridItems.filter(':visible').hasClass('active')) {
            $shadesFlyout.scrollTop(0);
            setTimeout(function () {
              $shadesFlyout.animate(
                {
                  scrollTop:
                    $overlayListItem.filter('.active:visible').last().position().top +
                    $shadesFlyout.scrollTop()
                },
                'slow'
              );
            }, 300);
          }
        } else {
          $activeGridItems = $template.find($shadesGridItem);
        }
        skuCount = $activeGridItems.filter(':visible').length;
        $('.js-sku-count', $filterInfo).text('(' + skuCount + ')');
        $('.js-sku-count', $filterContainer).text('');
        $('.js-product-full-shade--filter.active', $filterContainer)
          .find('.js-sku-count')
          .text('(' + skuCount + ')');
        self.loadSelectedShade(skuBaseId, colorFamily, $product, $shadesFilterItem);
        Drupal.behaviors.productVtoShadesV1.initShadesCarousel($template);
      });

      $shadesArray.on('mouseleave', function () {
        var skuBaseId = $product.data('sku-base-id');
        var skuData = prodcat.data.getSku(skuBaseId);

        $ffCopy.removeClass('hidden');
        $shadeName.text(skuData['SHADENAME']);
        $shadeDesc.text(skuData['SHADE_DESCRIPTION']);
        $shadeDot.css({ backgroundColor: skuData['HEX_VALUE_STRING'] });
      });

      $(document).trigger('product.colorFamilyLoaded');
    },

    initShadesCarousel: function ($container) {
      var $shadesItem = $('.js-product-vto-shades-grid-item:not(.hidden)', $container);
      var $shadesGrid = $('.js-product-vto-shades-grid', $container);
      var $shadesGridView = $('.js-product-vto-shades-grid-view', $container);
      var shadesItemLength = $shadesGridView.find($shadesItem).length;
      var shadesItemWidth = $shadesGridView.find($shadesItem).first().outerWidth(true);
      var shadesgridWidth = shadesItemLength * shadesItemWidth;

      $shadesGrid.width('');

      // Mobile carousel - set grid width for horizontal touch scrolling
      if (shadesItemLength >= 6) {
        $shadesGrid.width(shadesgridWidth);
      }
    },

    loadSelectedShade: function (skuBaseId, colorFamily, $product, $shadesFilterItem) {
      var skuData = prodcat.data.getSku(skuBaseId);
      var shadeName = _.result(skuData, 'SHADENAME');
      var shadeRouteName = prodcat.ui.generateShadePath(skuBaseId);

      if (!$shadesFilterItem) {
        history.replaceState({}, shadeName, shadeRouteName);
        return;
      }

      if (colorFamily !== $shadesFilterItem.first().text()) {
        if ($product.hasClass('product-full')) {
          history.replaceState({}, colorFamily, '#/family/' + colorFamily);
        }
      } else {
        history.replaceState({}, colorFamily, '#');
      }
    },

    showPerfectMatchTabSelected: function (context) {
      var $productFullShade = $('.js-product-vto-shades-v1', context);
      var $product = $productFullShade.closest('.js-product');
      var $hasPerfectMatch = $product.hasClass('contains-recommendation');
      var $shadesFlyout = $('.js-product-vto-shades-flyout-v2', $product);
      var $shadeTabPerfectMatch = $('.js-product-full-shade--perfect-match', $shadesFlyout);

      if (Boolean($hasPerfectMatch) && $shadeTabPerfectMatch.length > 0) {
        $shadeTabPerfectMatch.trigger('productShade:choosePerfectMatch');
      } else {
        $('.js-product-full-shade--filter', $productFullShade).first().trigger('click');
      }
    }
  };
})(jQuery);
